import type { ListPageConfig } from '@/lib/filters/types'

/**
 * Favourites had one filter — a search box — and so was written as a raw `<input>` with the
 * term in component state, never in the URL. That is the same shape `/agencies` was in before
 * W6: not a styling drift, a different component.
 *
 * The filter stays CLIENT-side (no `serverSide`). `myFavourites` is fetched whole with
 * `take: 200` and there is no server-side search argument on it, so the term narrows the
 * already-fetched rows. Marking it `serverSide` would put it in `serverFilters`, where this
 * page has nothing to send it to — it would silently do nothing.
 */
export const FAVOURITES_ROUTE_CONFIG: ListPageConfig = {
  routeId: '/favourites/',
  pageId: 'favourites',
  fields: [
    {
      id: 'q',
      label: 'Search',
      type: 'search',
      placeholder: 'Search favourites…',
    },
  ],
}
